import { render } from "./ModerationPanel.vue?vue&type=template&id=180e48ca&scoped=true"
import script from "./ModerationPanel.vue?vue&type=script&lang=js"
export * from "./ModerationPanel.vue?vue&type=script&lang=js"

import "./ModerationPanel.vue?vue&type=style&index=0&id=180e48ca&lang=scss"
import "./ModerationPanel.vue?vue&type=style&index=1&id=180e48ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180e48ca"]])

export default __exports__